import { ArrowUpRight, BookOpen } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function CTA() {
  const navigate = useNavigate();
  return (
    <section id="cta" className="cta">
      <div className="cta-bg"></div>
      <div className="container">
        <div className="eyebrow reveal" style={{ justifyContent: "center", display: "inline-flex" }}>
          / Get started
        </div>
        <h2 className="reveal d1">
          Powerful AI <em>doesn't require</em> surveillance.
        </h2>
        <p className="reveal d2" style={{ color: "var(--fg-dim)", maxWidth: "52ch", margin: "0 auto 36px" }}>
          Privacy, once lost, doesn't come back. Start using AI built — from the architecture up —
          to never need your data. $18.95 / month, no credit card surveillance, hash auth from day one.
        </p>
        <div className="actions reveal d3">
          <button onClick={() => navigate('/signup')} className="btn btn-primary">
            <span>Get started · $18.95/mo</span>
            <ArrowUpRight size={14} strokeWidth={1.5} />
          </button>
          <a href="#manifesto" className="btn">
            <BookOpen size={12} strokeWidth={1.5} />
            <span>Read the manifesto</span>
          </a>
        </div>
        <p className="reveal d3" style={{ marginTop: 28, fontFamily: "var(--mono)", fontSize: 11, letterSpacing: "0.16em", textTransform: "uppercase", color: "var(--fg-faint)" }}>
          By using QXAI you agree to the{" "}
          <a href="/terms" style={{ color: "var(--fg-dim)", borderBottom: "1px solid var(--rule)" }}>Terms</a>
          {" "}and{" "}
          <a href="/privacy" style={{ color: "var(--fg-dim)", borderBottom: "1px solid var(--rule)" }}>Privacy Policy</a>.
        </p>
      </div>
    </section>
  );
}
